import { RegistrationData } from "../../../types/User";

export const getRegistrationData = (): RegistrationData | null => {
  const storedData = typeof window !== "undefined" ? sessionStorage.getItem("GACRegistrationData") : null;
  if (storedData) {
    return JSON.parse(storedData);
  }
  return null;
};
